import { render, staticRenderFns } from "./updateImagesForm.vue?vue&type=template&id=365c6d20&scoped=true&"
import script from "./updateImagesForm.vue?vue&type=script&lang=ts&"
export * from "./updateImagesForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365c6d20",
  null
  
)

export default component.exports